import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";
import { ShieldAlert } from "lucide-react";
import api, { errMsg } from "../lib/api";

export function ForcePasswordChange({ open, onDone }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (next.length < 12) { toast.error("La nueva contraseña debe tener al menos 12 caracteres"); return; }
    if (next !== confirm) { toast.error("Las contraseñas no coinciden"); return; }
    if (next === current) { toast.error("La nueva contraseña debe ser diferente a la actual"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Contraseña actualizada correctamente");
      setCurrent(""); setNext(""); setConfirm("");
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={() => { /* forced — cannot close */ }}>
      <DialogContent className="rounded-none max-w-md [&_button.absolute]:hidden" data-testid="force-password-change">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-destructive">
            <ShieldAlert size={18} /> Cambio de contraseña requerido
          </DialogTitle>
          <DialogDescription>
            Por política de seguridad, debes cambiar tu contraseña antes de continuar.
            Requisitos: mínimo 12 caracteres, diferente a la actual.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-[10px] font-bold uppercase">Contraseña actual</Label>
            <Input type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
                   className="rounded-none h-9 text-xs" data-testid="fpc-current" autoComplete="current-password" />
          </div>
          <div>
            <Label className="text-[10px] font-bold uppercase">Nueva contraseña</Label>
            <Input type="password" value={next} onChange={(e) => setNext(e.target.value)}
                   className="rounded-none h-9 text-xs" data-testid="fpc-new" autoComplete="new-password" />
          </div>
          <div>
            <Label className="text-[10px] font-bold uppercase">Confirmar nueva contraseña</Label>
            <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                   className="rounded-none h-9 text-xs" data-testid="fpc-confirm" autoComplete="new-password" />
          </div>
          <Button className="w-full rounded-none text-xs font-bold" onClick={submit} disabled={busy}
                  data-testid="fpc-submit">
            {busy ? "Guardando…" : "Cambiar contraseña"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
